import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export const API_VERSION_HEADER = 'Accept-Version';
export const API_VERSION = '3.0';

@Injectable()
export class ApiVersionInterceptor implements HttpInterceptor {
  constructor() {  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers: HttpHeaders = req.headers;
    headers = headers.append(API_VERSION_HEADER, API_VERSION);
    req = req.clone({ headers });
    return next.handle(req);
  }
}
